import PropTypes from 'prop-types';
import {Size} from 'constants/UIComponentEnum';
import {FmlxIcon, FmlxPopover} from 'fmlx-common-ui';
import {useState} from 'react';

function PopupPipettingTipTouchOffInfo({labware, position}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const getImgByLabware = () => {
    if (!labware?.isTrough) {
      return `./svg/protocol-editor/tip-touch-circle-${position.toLowerCase()}.svg`;
    }
    if ((labware?.rowCount === 1 && labware?.colCount === 1) || labware?.rowCount === 8) {
      return './svg/protocol-editor/tip-touch-8through.svg';
    }
    if (labware?.colCount === 12) {
      return './svg/protocol-editor/tip-touch-12through.svg';
    }

    return '';
  };
  const onHoverHandler = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const onLeaveHandler = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div onMouseEnter={onHoverHandler} onMouseLeave={onLeaveHandler}>
        <FmlxIcon name="Info" size={Size.XS} />
      </div>
      <FmlxPopover anchorEl={anchorEl} isOverlay={false} anchorReference="anchorEl">
        <div style={{display: 'grid', gridTemplateColumns: '44% 45%', padding: '10px', gap: '5px'}}>
          <img src={getImgByLabware()} alt="Direction" />
        </div>
      </FmlxPopover>
    </>
  );
}

PopupPipettingTipTouchOffInfo.propTypes = {
  labware: PropTypes.object.isRequired,
  position: PropTypes.string,
};

PopupPipettingTipTouchOffInfo.defaultProps = {
  position: '',
};

export default PopupPipettingTipTouchOffInfo;
